import { WeightClassGroupWeight } from '@reg/shared/model';

export class WeightClassGroup {
    public id: string = null;
    public name: string = null;
    public measurementUnit: string = null;
    public weights: WeightClassGroupWeight[] = [];

    public clone(): WeightClassGroup {
        const clone: WeightClassGroup = new WeightClassGroup();
        clone.id = this.id;
        clone.name = this.name;
        clone.measurementUnit = this.measurementUnit;

        if (this.weights) {
            clone.weights = this.weights.map((w: WeightClassGroupWeight) => w.clone());
        }

        return clone;
    }

    public sortWeights(): void {
        if (!this.weights) {
            return;
        }

        this.weights = this.weights.sort((n1: WeightClassGroupWeight, n2: WeightClassGroupWeight) => {
            const sequence1: number = n1.sequence;
            const sequence2: number = n2.sequence;
            if (sequence1 > sequence2) {
                return 1;
            }

            if (sequence1 < sequence2) {
                return -1;
            }

            return 0;
        });
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: Object, included: any): WeightClassGroup {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'] || [];
        const relationships: Object = data['relationships'] || [];

        this.id = data['id'];
        this.name = attrs['name'];
        this.measurementUnit = attrs['measurementUnit'];

        const weightClassLinks: Object = relationships['weights'];
        if (weightClassLinks &&
            included &&
            weightClassLinks['data']) {
            this.weights = [];

            for (const weightClassLink of weightClassLinks['data']) {
                const weightClass: Object = included.filter((i: Object) => i['id'] === weightClassLink['id'])[0];
                if (weightClass) {
                    this.weights.push((new WeightClassGroupWeight()).deserialize(weightClass));
                }
            }

            this.sortWeights();
        }

        return this;
    }
}
